import { render, staticRenderFns } from "./OrderItemsTable.v2.vue?vue&type=template&id=809998c0&scoped=true"
import script from "./OrderItemsTable.v2.vue?vue&type=script&lang=js"
export * from "./OrderItemsTable.v2.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsTable.v2.vue?vue&type=style&index=0&id=809998c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809998c0",
  null
  
)

export default component.exports